import React from "react";
import { Box } from "@mui/material";
import { motion } from "framer-motion";
import { quizEntrance } from "../shared/quizMotion";
import { QuestionCard } from "../shared/QuestionCard";
import { QUIZ } from "@/theme/quizTokens";

type Props = {
  /** Currently selected number of dogs (the live dogs array length). */
  count: number;
  onSelect: (count: number) => void;
};

/**
 * Figma screen 1.0 — "HOW MANY DOGS DO YOU HAVE?".
 * Five number tiles; the selection resizes the dogs list. "1" starts selected,
 * matching the Figma default; Next confirms the current selection.
 */
export default function StepDogsCount({ count, onSelect }: Props) {
  return (
    <motion.div {...quizEntrance()}>
      <QuestionCard title="How many dogs do you have?" field="dogsCount">
        <Box sx={{ display: "flex", gap: { xs: "12px", md: "16px" }, justifyContent: "center" }}>
          {[1, 2, 3, 4, 5].map((n) => {
            const active = count === n;
            return (
              <Box
                key={n}
                role="button"
                aria-pressed={active}
                onClick={() => onSelect(n)}
                sx={{
                  width: { xs: 52, md: 64 },
                  height: { xs: 50, md: 62 },
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  userSelect: "none",
                  bgcolor: active ? QUIZ.color.brown : QUIZ.color.white,
                  color: active ? QUIZ.color.cream : "#b3aca6",
                  border: active ? `1px solid ${QUIZ.color.brown}` : "1px solid #e3ddd5",
                  boxShadow: "0px 2px 4px rgba(0,0,0,0.06)",
                  fontFamily: QUIZ.font.body,
                  fontWeight: 600,
                  fontSize: { xs: 24, md: 28 },
                  lineHeight: 1,
                  transition: "background-color 0.15s ease, color 0.15s ease",
                  "&:hover": { borderColor: QUIZ.color.brown },
                }}
              >
                {n}
              </Box>
            );
          })}
        </Box>
      </QuestionCard>
    </motion.div>
  );
}
